<template>
  <main-farme>
    <div slot="aside-left">
      <el-card shadow="never"
               style="width:400px">
        <div slot="header">
          <span @click="checkTraverPoint">
            <el-link :underline="false"
                     type="danger"> {{traver_title}}</el-link>
            的游玩指南
          </span>

        </div>

        <!-- 封面图 -->
        <show-image :src="traver_cover"
                    :image_type_name="'guide_cover_guide_id_'+guide_id"
                    api_name="add_image"
                    @getImageURl="getImageURl"></show-image>

        <input-modify :showEditorButtom="true"
                      :title="guide_title"
                      @saveInputContent="renewGuideTitlt"></input-modify>
        <!-- 概括编辑器 -->
        <el-divider></el-divider>
        <editor-intro title="游玩指南简介"
                      @save="saveGuideIntroduce"
                      :upLoadImgAddress="`${$ip}/add_image?key_name=guide_group_introduce_${this.guide_id}`"
                      :show_content="showGuideGroupInfo"></editor-intro>

      </el-card>
      <!-- 删除 -->
      <el-button @click="deleteGuideGroup"
                 type="primary"
                 style="width: 100%; padding: 10px ; margin-top:10px">删除指南</el-button>
    </div>
    <div slot="main">
      <el-card shadow="never"
               style="width:700px">
        <!-- 地图路线 -->
        <div>
          <show-guide-group-point ref="show_route_maps"></show-guide-group-point>
        </div>
        <el-divider></el-divider>
        <!-- ----------------------添加一个游玩点：游玩点名称、图文介绍、周边：poi、内容：---------------------- -->
        <!-- 添加游玩点：根据类型确认分类 -->
        <div v-for="(item,index) in guide_list"
             :key="index">
          <!-- 展示/编辑器 -->
          <div class="editor-introduce-place"
               style="margin-bottom:10px">
            <!-- 绑定内容 -->
            <editor-v2 id="guide_point_editor"
                       :upLoadImgAddress="`${$ip}/add_image?key_name=guide_point_introduce_${item.id}`"
                       :showButtonFirst="true"
                       :showBandPoi="item.poi_id != null"
                       :showButtonSecond="true"
                       :showButtonThird="true"
                       :show_content="item.point_introduce"
                       @firstButtonClick="changeTitleClick(item.id)"
                       @secondButtonClick="deleteButtonClick(item.id)"
                       @thirdButtonClick="openSelectContentClick(item)"
                       @fourthButtonClick="selectPoiOnMapClick(item)"
                       @save="saveGuidePointer"
                       :attribuite="item.id"
                       :index="index"
                       :title="item.title">
              <!-- 绑定定位 -->
              <div slot="add-block">
                <!-- <div v-if="item.showMap">
                  <select-or-add-poi-list @submitPoi="bandPoiToGuidePointer"
                                          @closeSubmitPOI="closeSubmitPOI(item)"
                                          :attribute="item.id"
                                          :proplat="item.lat"
                                          :proplng="item.lng"></select-or-add-poi-list>
                </div> -->
                <!-- :visible.sync="item.showMap" -->
                <el-dialog :visible.sync="item.showMap"
                           :append-to-body="true"
                           width="70%">
                  <select-or-add-poi-list-mini @submitPoi="bandPoiToGuidePointer"
                                               @closeSubmitPOI="closeSubmitPOI(item)"
                                               :attribute="item.id"
                                               :proplat="item.lat"
                                               :proplng="item.lng"></select-or-add-poi-list-mini>
                </el-dialog>
              </div>
            </editor-v2>

          </div>
          <!-- 关联的内容 -->
          <div class="guide-group-content-media-list">
            <el-card class="guide-group-content-media-item"
                     :body-style="{ padding: '0px' }"
                     v-for="item,index in item.content_media"
                     :key="index">

              <!-- 卡片样式 -->
              <el-image class="image-content-style"
                        fit="cover"
                        :src="item.content_cover"></el-image>
              <div style="padding: 10px;">
                <div>{{item.content_title}}</div>
                <div>{{item.content_introduce}}</div>
              </div>
              <!-- 删除样式 和查看 -->
              <div class="delect-and-check-content">
                <span @click="removeContent(item.content_id)"
                      style="margin-right:10px;color:#FFF;cursor: pointer;">删除</span>
                <span style="color:#FFF">|</span>
                <span @click="checkContent(item.content_id)"
                      style="margin-left:10px;color:#FFF;cursor: pointer;">查看</span>
              </div>
            </el-card>
          </div>

        </div>
        <!-- 绑定内容 -->
        <select-and-search-content :show.sync="showContentSelect"
                                   @bandTraverContent="bandTraverContent"></select-and-search-content>
        <!------------------------ 添加按钮 ---------------------- -->
        <button-auto @clickBtn="addGuidePoint"></button-auto>
        <!-- 提交 -->
        <!-- <div style="text-align:center">
          <el-button size="mini"
                     type="primary">提交</el-button>
        </div> -->

      </el-card>
    </div>
  </main-farme>
</template>

<script>
import ShowGuideGroupPoint from '../../components/map/ShowGuideGroupPoint'
import MainFrameCenter from '../../components/common/main/MainFrameCenter'
import ShowImageAndUpLoad from '../../components/common/other/ShowImageAndUpLoad'
import ButtonAutoWidth from '../../components/common/button/ButtonAutoWidth'
import Editor from '../../components/common/modify/EditorV2ModifyMini'
// import EditorV2 from '../../components/common/editor/editorV1'
import EditorV2 from '../../components/common/modify/EditorV2Modify'
import SelectAndSearchContent from '../../components/common/select/SelectAndSearchContent'
// 绑定坐标
import SelectOrAddPoiListMini from '../../components/map/SelectOrAddPoiListMini'
import ShowTitleAndModify from '../../components/common/modify/ShowTitleAndModify'
export default {
  name: 'guide-group-detail',
  components: {
    'show-guide-group-point': ShowGuideGroupPoint,
    'input-modify': ShowTitleAndModify,
    'main-farme': MainFrameCenter,
    'show-image': ShowImageAndUpLoad,
    'button-auto': ButtonAutoWidth,
    'editor-intro': Editor,
    'editor-v2': EditorV2,
    'select-and-search-content': SelectAndSearchContent,
    'select-or-add-poi-list-mini': SelectOrAddPoiListMini,
  },
  data() {
    return {
      guide_title: '',
      traver_id: null,
      traver_title: '',
      traver_cover: '',
      showGuideGroupInfo: '',
      guide_id: null,
      guide_list: [],
      showContentSelect: false,
      band_content_id: null,
    }
  },
  watch: {
    guide_list(val) {
      this.guide_list = val
    },
  },
  mounted() {
    this.guide_id = this.$route.query.guide_id
    this.getGuideGroup(this.guide_id)
    this.getAllGuidePoint(this.guide_id)
  },
  methods: {
    deleteGuideGroup() {
      this.$confirm('此操作将永久删除该指南, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .get(`/traver/delete_guide_group?guide_id=${this.guide_id}`)
            .then((res) => {
              if (res.data.errno == '0') {
                this.$message({
                  type: 'success',
                  message: res.data.errmsg,
                })
                this.$router.push(
                  `/check_traver_point?traver_id=${this.traver_id}`
                )
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    removeContent(content_id) {
      console.log(content_id)
    },
    checkContent(content_id) {
      console.log(content_id)
    },
    //
    renewGuideTitlt(val) {
      // console.log(val)
      this.$http
        .get(
          `/traver/change_traver_guide_name?guide_id=${this.guide_id}&guide_name=${val}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 获取 基本信息
    getGuideGroup(guide_id) {
      this.$http
        .get(`/traver/get_guide_info?guide_id=${guide_id}`)
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            this.guide_title = res.data.data.guide_title
            this.traver_id = res.data.data.traver_id
            this.traver_title = res.data.data.traver_title
            this.traver_cover = res.data.data.guide_cover
            this.showGuideGroupInfo = res.data.data.guide_introduce
          }
        })
    },
    // 根据 guide_id 获取 游玩点
    getAllGuidePoint(guide_id) {
      this.$http
        .get(`/traver/get_traver_guide_pointer?guide_id=${guide_id}`)
        .then((res) => {
          console.log(res)
          let lat_lng_list = []
          if (res.data.errno == '0') {
            let g_data = res.data.guide_data
            // 是否为空
            if (g_data.length != 0) {
              g_data.forEach((i) => {
                let guide_item = {
                  id: i.id,
                  title: i.point_name,
                  type: i.type,
                  index: i.index,
                  poi_id: i.poi_id,
                  point_introduce: i.point_introduce,
                  content_media: i.content,
                  showMap: false,
                }
                // 添加到列表
                this.guide_list.push(guide_item)
                // 坐标

                if (i.lat != null) {
                  let item = {
                    lat: parseFloat(i.lat),
                    lng: parseFloat(i.lng),
                  }
                  lat_lng_list.push(item)
                }
              })
              this.$refs.show_route_maps.addMarkerPointer(lat_lng_list)
            }
          }
        })
    },
    getImageURl(url) {
      this.$http
        .post('/traver/change_guide_cover', {
          guide_id: this.guide_id,
          guide_cover: url,
        })
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.traver_cover = url
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    addGuidePoint() {
      // 添加游玩点
      this.$prompt('请输入游玩点名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          // 添加item
          let guide_item = {
            type: 'guide',
            title: value,
            id: 4,
          }
          // 接口 添加游玩点
          this.$http
            .get(
              `/traver/add_traver_guide_pointer?guide_id=${this.guide_id}&pointer_name=${value}&type='guide'`
            )
            .then((res) => {
              console.log(res)
            })
          this.guide_list.push(guide_item)
          // 添加message
          this.$message({
            type: 'success',
            message: '添加成功',
          })
        })
        .catch(() => {
          this.$message({
            type: 'danger',
            message: '取消',
          })
        })
    },
    saveGuideIntroduce(intro) {
      let postGuide = {
        guide_id: this.guide_id,
        guide_introduce: intro,
      }
      this.$http
        .post('/traver/change_traver_guide_introduce', postGuide)
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.showGuideGroupInfo = intro
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    saveGuidePointer(val, id) {
      let post_item = {
        point_id: id,
        point_introduce: val,
      }
      this.$http.post('/traver/add_pointer_intro', post_item).then((res) => {
        // console.log(res)
        if (res.data.errno == '0') {
          this.$message({
            message: res.data.errmsg,
            type: 'success',
          })
          this.guide_list = []
          this.getAllGuidePoint(this.guide_id)
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
    },
    // 打卡选择内容的对话框
    openSelectContentClick(guide_pointer) {
      this.showContentSelect = true
      // console.log(guide_pointer)
      this.band_content_id = guide_pointer.id
    },
    checkTraverPoint() {
      this.$router.push(`/check_traver_point?traver_id=${this.traver_id}`)
    },
    // 绑定内容给 guide_poi_id
    bandTraverContent(content_id) {
      // console.log(content_id)
      this.$http
        .get(
          `/traver/band_content_to_pointer?guide_pointer_id=${this.band_content_id}&content_id_list=${content_id}`
        )
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.showContentSelect = false
            this.guide_list = []
            this.getGuideGroup(this.guide_id)
            this.getAllGuidePoint(this.guide_id)
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 修改 游玩点名称
    changeTitleClick(guide_point_id) {
      this.$prompt('新游玩点名称', '修改游玩点名称：', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          this.$http
            .get(
              `/traver/change_pointer_title?guide_point_id=${guide_point_id}&point_name=${value}`
            )
            .then((res) => {
              // console.log(res)
              if (res.data.errno == '0') {
                this.$message({
                  message: res.data.errmsg,
                  type: 'success',
                })
                this.guide_list = []
                this.getAllGuidePoint(this.guide_id)
              } else {
                this.$message({
                  message: res.data.errmsg,
                  type: 'error',
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          })
        })
    },
    // 添加 定位给 游玩点
    bandPoiToGuidePointer(poi_id, point_id) {
      // 绑定 游玩点
      this.$http
        .get(
          `/traver/band_poi_to_guide_pointer?poi_id=${poi_id}&point_id=${point_id}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            //
            this.guide_list.forEach((i) => {
              if (i.id == point_id) {
                i.showMap = false
              }
            })
            //
            this.guide_list = []
            this.getAllGuidePoint(this.guide_id)
            //
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })

      // 关闭页面
    },
    // 关 地图
    closeSubmitPOI(item) {
      item.showMap = false
    },
    // 打开选点地图对话框
    selectPoiOnMapClick(item) {
      console.log(item)
      // this.showMapSelect = !this.showMapSelect
      item.showMap = !item.showMap
    },
    // 删除poi
    deleteButtonClick(i) {
      // console.log('删除poi', i)
      this.$http
        .get(`/traver/delete_traver_guide_pointer?point_id=${i}`)
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.getGuideGroup(this.guide_id)
            this.getAllGuidePoint(this.guide_id)
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
  },
}
</script>

<style>
#guide_point_editor .ql-container {
  background-color: #fff;
}
.editor-introduce-place {
  background-color: cornsilk;
  padding: 10px;
  margin-bottom: 10px;
}

.lable-traver-guide {
  margin: 20px 0;
}

.guide-group-content-media-list {
  display: flex;
}

.guide-group-content-media-item {
  width: 23%;
  border: 1px solid lightcyan;
  border-radius: 10px;
  margin-bottom: 20px;
}

.delect-and-check-content {
  text-align: center;
  display: none;
}

.guide-group-content-media-item:hover .delect-and-check-content {
  display: block;
  background-color: darkgray;
}

.image-content-style {
  height: 50px;
}
</style>